// extracted by mini-css-extract-plugin
var _1 = "background___VE8a9";
export { _1 as "background" }
